// The burn bar's wording.
//
// Separate from burn.js on purpose. That file is arithmetic and this one is
// English, and the split is what lets the phrasing change without touching a
// module whose assertions are about numbers.
//
// Pure, like burn.js: no React, no network, loadable by the probe shim.
//
// One sentence, three shapes, no adjectives and no verdict — the bar's one
// boundary is maintenance, and this names which side of it the day is on:
//
//   intake < burn  ->  "1,561 available"
//   intake > burn  ->  "320 over maintenance"
//   rounded 0      ->  "at maintenance"
//
// "available" is warm because it is useful, not because it congratulates —
// the same number, the plainer reading. The number prints whole and exact:
// the sentence contains one figure, and it is the same subtraction the reader
// could do from the figures already on screen.
export function formatDeficitHeadline(deficitCal) {
  if (typeof deficitCal !== 'number' || !Number.isFinite(deficitCal)) {
    throw new Error(`formatDeficitHeadline: expected a finite deficit, got ${JSON.stringify(deficitCal)}`);
  }

  const rounded = Math.round(deficitCal);
  const n = value => Math.abs(value).toLocaleString('en-US');

  if (rounded > 0) return `${n(rounded)} available`;
  if (rounded < 0) return `${n(rounded)} over maintenance`;
  return 'at maintenance';
}
